/** global type FileWithPath from react-dropzone */
export interface FileWithPath extends File {
  path?: string;
  handle?: FileSystemFileHandle;
  relativePath?: string;
}

/** global type FileObject from react-dropzone */
export type FileObject = {
  file: FileWithPath & { preview: string };
  data: string | ArrayBuffer | null; // Base64 Data URL
};

/** global type FileDropErrorCode from react-dropzone */
export enum FileDropErrorCode {
  FileInvalidType = "file-invalid-type",
  FileTooLarge = "file-too-large",
  FileTooSmall = "file-too-small",
  TooManyFiles = "too-many-files"
}

/** global type FileError from react-dropzone */
export interface FileError {
  message: string;
  code: FileDropErrorCode | string;
}

/** global type FileRejection from react-dropzone */
export interface FileRejection {
  file: FileWithPath;
  errors: readonly FileError[];
}
